export const common = {
  call: 'Call ',
  cancel: 'CANCEL',
  chat_ready: 'Chat with client is ready!',
  contact: 'Contact',
  desktop_only_message: 'This application may only be used on Desktop. Please visit this website on a compatible device or resize your browser window.',
  email: 'Email',
  hours: 'Monday - Friday, <nobr>8 am - 7 pm ET</nobr>',
  loading: 'Loading...',
  log_in: 'Log In',
  log_out: 'Log Out',
  logging_in: 'Logging in...',
  logging_out: 'Logging out...',
  setting_up_connection: 'Setting up client & connection...',
  submit: 'SUBMIT',
} as const;

export type CommonNamespace = Record<keyof typeof common, string>;
